module.exports = __webpack_public_path__ + "img/open.18466b51.png";